module.exports = __webpack_public_path__ + "img/slider-12.dec6f083.jpg";